import Asterra1 from '../../../Media/Ruko BSD/Asterra/Asterra.webp'
import Asterra2 from '../../../Media/Ruko BSD/Asterra/Asterra.webp'

const Asterraimages =[
Asterra1,Asterra2
]

export default Asterraimages;
